import React from "react";
import PropTypes from "prop-types";

// Fills up to the target and turns green once it is reached
const TargetBar = ({ share }) => (
  <div className="w-full h-1.5 bg-gray-100 rounded-full dark:bg-gray-700">
    <div
      className={"h-1.5 rounded-full " + (share >= 1 ? "bg-green-500" : "bg-purple-600")}
      style={{ width: `${Math.min(Math.max(share, 0), 1) * 100}%` }}
    />
  </div>
);

TargetBar.propTypes = { share: PropTypes.number.isRequired };

export default TargetBar;
